module.exports = __webpack_public_path__ + "img/bb_g3_ears-06.6e5c54c0.svg";